import { prefixUrl } from "../../../configuration/config";
import { takeEvery, put, call, apply, select } from "redux-saga/effects";
import { request } from '../../../openid/request';
import { selectors as notificationManagerSelectors } from '../../NotificationManager';
import {
    actions as manageViewActions,
    types as manageViewTypes
} from "../reducer";

function* saga(action) {

    const {
        id,
        successMessage,
        failMessage,
        extensionPackage
    } = action.payload;

    const formData = new FormData();
    formData.append("File", extensionPackage);

    const fetchParams = [
        `${prefixUrl}/addon/api/v1/Addons/${id}`,
        {
            method: "PUT",
            body: formData
        },
    ];

    try {
        const response = yield call(request, ...fetchParams);

        switch (response.status) {
            case 200:
                const data = yield apply(response, response.json);
                data.isModified
                    ? yield put(manageViewActions.registerNotificationSuccess({ successMessage: successMessage.modified }))
                    : yield put(manageViewActions.registerNotificationSuccess({ successMessage: successMessage.notModified }));
                yield put(manageViewActions.getAddon({ id }));
                break;
            case 400:
                throw yield apply(response, response.json);
            case 401:
            case 403:
                yield put(manageViewActions.getListAddons_failed({
                    data: [response.statusText],
                    failMessage: yield select(state => notificationManagerSelectors.getAuthMessage(state.notificationManager))
                }));
                break;
            default:
                throw response.statusText;
        }
    }
    catch (data) {
        yield put(manageViewActions.registerNotificationFailed({
            data: [data],
            failMessage
        }));
    }
}

export default function* () {

    yield takeEvery(manageViewTypes.PUT_PACKAGE, saga);
}
